import React, { useEffect, useState } from "react";
import { Button, Table, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { Content, ContentSortOrder, ContentSortMode } from "../../../common/types";
import { Link } from "react-router-dom";
import { FavoriteBadge } from "./ContentBadges";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { ExternalLink } from "../../../common/components/Links";

interface OwnProps {
    content: Content[];
    sortBy: ContentSortMode;
    setSortBy: React.Dispatch<React.SetStateAction<ContentSortMode>>;
    sortOrder: ContentSortOrder;
    setSortOrder: React.Dispatch<React.SetStateAction<ContentSortOrder>>;
}

const ContentList = ({ content, sortBy, setSortBy, setSortOrder }: OwnProps) => {
    const asc = "&#8593;";
    const desc = "&#8595;"
    const [orderIcon, setOrderIcon] = useState(desc);

    const setOrder = () => {
        if (orderIcon === asc) {
            setSortOrder("desc");
            setOrderIcon(desc);
        } else {
            setSortOrder("asc");
            setOrderIcon(asc);
        }
    };

    return <Table variant={"unstyled"} size={"sm"} maxW={"100%"}>
        <Thead>
            <Tr>
                <Th>
                    <Button size="sm" display={"flex"} variant="unstyled" padding={0} onClick={() => {
                        setSortBy("title");
                        setOrder();
                    }}>
                        T&#237;tulo &nbsp;
                        {sortBy === "title" &&
                            <div dangerouslySetInnerHTML={{ __html: orderIcon }}></div>
                        }
                    </Button>
                </Th>
                <Th>
                    <Button size="sm" display={"flex"} variant="unstyled" padding={0} onClick={() => {
                        setSortBy("latest");
                        setOrder();
                    }}>
                        Creaci&#243;n &nbsp;
                        {sortBy === "latest" &&
                            <div dangerouslySetInnerHTML={{ __html: orderIcon }}></div>
                        }
                    </Button>
                </Th>
                <Th>
                    <Button size="sm" display={"flex"} variant="unstyled" padding={0} onClick={() => {
                        setSortBy("updated");
                        setOrder();
                    }}>
                        Actualizaci&#243;n &nbsp;
                        {sortBy === "updated" &&
                            <div dangerouslySetInnerHTML={{ __html: orderIcon }}></div>
                        }
                    </Button>
                </Th>
            </Tr>
        </Thead>
        {content.map((c, i) => {
            const created = (new Date(c.createdAt)).toDateString();
            const updated = c.updatedAt ? (new Date(c.updatedAt)).toDateString() : created;
            return <Tr key={i}>
                <Td>
                    <Link to={`/contents/${c._id}`}>
                        <Text
                            as="u"
                            fontSize="md"
                            textColor="blue.600"
                            fontWeight="bold"
                        >
                            {c.isFavorite && <FavoriteBadge />}
                            {c.title != "" ? c.title : "<sin título>"}
                        </Text>
                    </Link>
                        {c.contentType === "website" && 
                            <>
                            &nbsp;
                            <ExternalLink url={c.url!} size="lg"/>
                            </>
                        }
                </Td>
                <Td>
                    <span>{created}</span>
                </Td>
                <Td>
                    <span>{updated}</span>
                </Td>
            </Tr>;
        })}
    </Table>;
}

export default ContentList;